// extracted by mini-css-extract-plugin
export default {"container":"TP-z","topReviewHeading":"UP-z","criticalReview":"VP-z","favorableReview":"WP-z","vsSeparator":"XP-z"};